/**
 * Pack for various apps that should not be initialized on each request
 * but are small enough to bundle multiple into a single pack.
 *
 * Eg. Search Results page
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import { configureStore } from 'store/configureStore';
import { SearchResults } from 'components/search/SearchResults';
import { ArtworkCategoryEditor } from 'apps/artwork-category-editor';

const store = configureStore();

/**
 * Search Results
 */
const searchResultsApp = document.getElementsByClassName('js-search-results-app')[0];

if (searchResultsApp) {
  ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter>
        <SearchResults />
      </BrowserRouter>
    </Provider>,
    searchResultsApp,
  );
}

/**
 * Artwork Category Editor
 */
const container = document.getElementsByClassName('js-artwork-category-editor')[0] as HTMLElement;
const artworkId = container?.dataset?.artworkId
  ? parseInt(container.dataset.artworkId, 10)
  : undefined;

if (container && artworkId) {
  const tagsLimit = parseInt(container?.dataset?.limit || '', 10);
  const inputId = container.dataset.inputId;

  ReactDOM.render(
    <ArtworkCategoryEditor
      artworkId={artworkId}
      limit={Number.isNaN(tagsLimit) ? undefined : tagsLimit}
      limitReachedMessage='Tags limit reached'
      inputId={inputId}
    />,
    container,
  );
}
